export default __webpack_public_path__ + "static/media/IconDesc_ModularFrameHeavy.64.cc385693.png";